export default __webpack_public_path__ + "static/media/arrow-up-dark.9f14359b.svg";